import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const LedaAbout = () => (
  <>
    <Header />
    {/* About Us Section */}
    <section className="bg-white py-20">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6 text-slate-900">About us</h2>
        <p className="mb-6">
          LEDA Group was founded by Leon Cozier with Callum Baker, who together
          bring over 40 years of experience in the construction sector. Known
          for delivering speed, reliability, and quality, LEDA provides tailored
          recruitment solutions across trade, labour, and management.
        </p>
        <p className="mb-12">
          Knowing the challenges of construction recruitment, Leon & Callum have
          assembled an experienced team of sector specialists, each with no less
          than 15 years experience, to ensure seamless service & delivery.
        </p>
        <h3 className="text-2xl font-bold mb-6">Why choose LEDA?</h3>
        <div className="grid grid-rows-3 md:grid-cols-3 md:grid-rows-none gap-6 text-left">
          <div className="border p-4 rounded">
            <h4 className="font-bold text-lg mb-2">Speed & Reliability</h4>
            <p>
              We understand the fast-paced nature of construction and deliver
              quickly.
            </p>
          </div>
          <div className="border p-4 rounded">
            <h4 className="font-bold text-lg mb-2">Industry Expertise</h4>
            <p>
              Led by Leon Cozier and backed by a team that knows the sector
              inside out.
            </p>
          </div>
          <div className="border p-4 rounded">
            <h4 className="font-bold text-lg mb-2">Tailored Solutions</h4>
            <p>
              We match the right people to the right roles, ensuring quality and
              efficiency.
            </p>
          </div>
          <div className="row-span-3 md:col-span-3 border p-4 rounded">
            <h4 className="font-bold mb-2">Technology</h4>
            <p>
              We embrace and invest in the latest technology to support our team
              and deliver top results for clients and candidates.
            </p>
          </div>
          <div className="row-span-3 md:col-span-3 border p-4 rounded">
            <h4 className="font-bold text-green-600 mb-2">Sustainability</h4>
            <p>
              In partnership with&nbsp;
              <a href="https://www.greenredeem.co.uk/one-tonne-challenge-leda/" target="_blank" className="text-blue-600 underline">
                Greenredeem
              </a>
              , we help businesses report positive environmental actions,
              enhance ESG credentials, and strengthen tender submissions.
            </p>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </>
);

export default LedaAbout;
